import { ChevronRight } from 'lucide-react';

interface PathBreadcrumbProps {
  path: string[];
  maxVisible?: number;
}

export function PathBreadcrumb({ path, maxVisible = 5 }: PathBreadcrumbProps) {
  const displayPath = path.length > maxVisible
    ? [...path.slice(0, 2), '...', ...path.slice(-2)]
    : path;

  return (
    <div className="path-breadcrumb">
      {displayPath.map((item, index) => (
        <div key={index} className="flex items-center gap-2">
          {index > 0 && <ChevronRight className="w-3 h-3 text-muted-foreground/50" />}
          <span className={`
            ${item === '...' ? 'text-muted-foreground' : ''}
            ${index === path.length - 1 ? 'text-primary font-medium' : ''}
          `}>
            {item}
          </span>
        </div>
      ))}
    </div>
  );
}
